import { STORAGE_KEYS } from '../config/cognito';
import { AuthTokens, CognitoUser } from '../types';

class StorageService {
  private storage: Storage;

  constructor(storage: Storage = localStorage) {
    this.storage = storage;
  }

  // Token management
  setTokens(tokens: AuthTokens): void {
    this.storage.setItem(STORAGE_KEYS.ACCESS_TOKEN, tokens.accessToken);
    this.storage.setItem(STORAGE_KEYS.ID_TOKEN, tokens.idToken);
    this.storage.setItem(STORAGE_KEYS.REFRESH_TOKEN, tokens.refreshToken);
  }

  getTokens(): AuthTokens | null {
    const accessToken = this.storage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
    const idToken = this.storage.getItem(STORAGE_KEYS.ID_TOKEN);
    const refreshToken = this.storage.getItem(STORAGE_KEYS.REFRESH_TOKEN);

    if (!accessToken || !idToken || !refreshToken) {
      return null;
    }

    return { accessToken, idToken, refreshToken };
  }

  clearTokens(): void {
    this.storage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
    this.storage.removeItem(STORAGE_KEYS.ID_TOKEN);
    this.storage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
  }

  // User data
  setUserData(user: CognitoUser): void {
    this.storage.setItem(STORAGE_KEYS.USER_DATA, JSON.stringify(user));
  }

  getUserData(): CognitoUser | null {
    const data = this.storage.getItem(STORAGE_KEYS.USER_DATA);
    return data ? JSON.parse(data) : null;
  }

  clearUserData(): void {
    this.storage.removeItem(STORAGE_KEYS.USER_DATA);
  }

  // OAuth state management
  setAuthState(state: string): void {
    this.storage.setItem(STORAGE_KEYS.AUTH_STATE, state);
  }

  getAuthState(): string | null {
    return this.storage.getItem(STORAGE_KEYS.AUTH_STATE);
  }

  clearAuthState(): void {
    this.storage.removeItem(STORAGE_KEYS.AUTH_STATE);
  }

  // Clear all auth data
  clearAll(): void {
    this.clearTokens();
    this.clearUserData();
    this.clearAuthState();
  }
}

export const storageService = new StorageService();